import React, { useState, Fragment } from 'react';
import { Lock, TrendingUp, Target, Users, DollarSign, Zap, X, ChevronRight } from 'lucide-react';
export const InvestorLandingPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isBusinessCaseOpen, setIsBusinessCaseOpen] = useState(false);
  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simple password check - in production, use proper authentication
    if (password === 'gigi2025') {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password');
    }
  };
  if (!isAuthenticated) {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-850">
        <div className="max-w-md w-full" data-id="element-851">
          <div className="bg-white rounded-xl shadow-lg p-8" data-id="element-852">
            <div className="flex justify-center mb-6" data-id="element-853">
              <div className="w-16 h-16 bg-[#6366f1]/10 rounded-xl flex items-center justify-center" data-id="element-854">
                <Lock className="w-8 h-8 text-[#6366f1]" data-id="element-855" />
              </div>
            </div>
            <h2 className="text-2xl font-bold text-center text-gray-900 mb-2" data-id="element-856">
              Investor Access
            </h2>
            <p className="text-center text-gray-600 mb-6" data-id="element-857">
              Enter password to view Pre-Seed materials
            </p>
            <form onSubmit={handlePasswordSubmit} data-id="element-858">
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none mb-4" data-id="element-859" />
              {error && <p className="text-red-600 text-sm mb-4 text-center" data-id="element-860">{error}</p>}
              <button type="submit" className="w-full py-3 bg-[#6366f1] text-white rounded-lg hover:bg-[#5457e5] font-semibold transition-colors" data-id="element-861">
                Access Materials
              </button>
            </form>
          </div>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-white" data-id="element-862">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-[#6366f1]/5 to-white pt-20 pb-16" data-id="element-863">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-864">
          <div className="text-center" data-id="element-865">
            <div className="inline-block px-4 py-1.5 bg-[#6366f1]/10 rounded-full text-[#6366f1] font-medium text-sm mb-6" data-id="element-866">
              Pre-Seed Round • $100K
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-6" data-id="element-867">
              UseGigi.ai
            </h1>
            <p className="text-3xl text-gray-900 font-bold mb-4 leading-tight" data-id="element-868">
              Turning B2B Outreach from Spam
              <br data-id="element-869" />
              into Conversations That Convert
            </p>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8" data-id="element-870">
              The first end-to-end AI SDR platform that combines behavioral
              psychology with automation—delivering 5x higher reply rates than
              traditional tools while replacing a $50K+ fragmented tech stack.
            </p>
            <div className="flex justify-center gap-8 mt-8" data-id="element-871">
              <div className="text-center" data-id="element-872">
                <div className="text-3xl font-bold text-[#6366f1]" data-id="element-873">20-27%</div>
                <div className="text-sm text-gray-600" data-id="element-874">Reply Rate</div>
                <div className="text-xs text-gray-500" data-id="element-875">
                  (vs 4-5% industry avg)
                </div>
              </div>
              <div className="text-center" data-id="element-876">
                <div className="text-3xl font-bold text-[#6366f1]" data-id="element-877">3x</div>
                <div className="text-sm text-gray-600" data-id="element-878">Meeting Bookings</div>
                <div className="text-xs text-gray-500" data-id="element-879">(proven results)</div>
              </div>
              <div className="text-center" data-id="element-880">
                <div className="text-3xl font-bold text-[#6366f1]" data-id="element-881">1</div>
                <div className="text-sm text-gray-600" data-id="element-882">Platform</div>
                <div className="text-xs text-gray-500" data-id="element-883">
                  (replaces 5-7 tools)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Problem Section */}
      <section className="py-16 bg-gray-50" data-id="element-884">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-885">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-886">The Problem</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-887">
            <ProblemCard title="Manual Chaos" description="SDRs spend 80% of time on research and data entry, not selling" data-id="element-888" />
            <ProblemCard title="Generic Outreach" description="Mass personalization tools still feel robotic—4-5% reply rates prove it" data-id="element-889" />
            <ProblemCard title="Fragmented Stack" description="Teams juggle 5-7 tools for prospecting, messaging, and follow-ups" data-id="element-890" />
          </div>
        </div>
      </section>
      {/* Solution Section */}
      <section className="py-16 bg-white" data-id="element-891">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-892">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-893">
            What is UseGigi.ai
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-894">
            An end-to-end AI SDR platform that goes from{' '}
            <strong data-id="element-895">natural language onboarding</strong> →
            <strong data-id="element-896"> ICP definition</strong> →{' '}
            <strong data-id="element-897">LinkedIn data scraping</strong> →
            <strong data-id="element-898"> psychographic profiling</strong> →{' '}
            <strong data-id="element-899">AI-generated messaging</strong> →
            <strong data-id="element-900"> automated outreach + follow-ups</strong>.
          </p>
          <div className="bg-[#6366f1]/5 rounded-xl p-8 mb-8" data-id="element-901">
            <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-902">
              The Gigi Difference: Why This Matters
            </h3>
            <div className="mb-8" data-id="element-903">
              <p className="text-lg text-gray-700 mb-4" data-id="element-904">
                <strong data-id="element-905">
                  Every competitor treats AI sales tools as either data
                  enrichment OR message generation OR automation.
                </strong>{' '}
                Gigi is the first platform that combines all three with
                behavioral psychology—creating a system that thinks like a top
                SDR, not just a chatbot.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-906">
              <FeatureItem title="Built by People Who Actually Sell" description="Not theoretical—battle-tested daily in Set-Sell.com's real client campaigns. Every feature solves a problem we've personally hit 1000+ times." data-id="element-907" />
              <FeatureItem title="Psychology-First, Not Template-First" description="Analyzes how prospects think and communicate before crafting messages. This is why we hit 20-27% reply rates vs. industry's 4-5%." data-id="element-908" />
              <FeatureItem title="Chat Interface = Zero Learning Curve" description="No complex dashboards or CSV uploads. Talk to Gigi like you'd brief a human SDR. This makes enterprise-grade AI accessible to SMBs." data-id="element-909" />
              <FeatureItem title="The Only True End-to-End Solution" description="From 'who should I target?' to 'meeting booked'—one platform, one workflow. Competitors force you to stitch together 5-7 tools." data-id="element-910" />
            </div>
            <div className="mt-8 bg-white rounded-lg p-6 border-2 border-[#6366f1]" data-id="element-911">
              <p className="text-gray-900 font-semibold text-lg mb-2" data-id="element-912">
                The Core Insight:
              </p>
              <p className="text-gray-700" data-id="element-913">
                Most AI sales tools optimize for <em data-id="element-914">efficiency</em>. Gigi
                optimizes for <strong data-id="element-915">effectiveness</strong>—understanding that
                a 27% reply rate with 100 prospects beats a 5% reply rate with
                1000 prospects. This changes the unit economics of B2B sales.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Traction Section */}
      <section className="py-16 bg-gray-50" data-id="element-916">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-917">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-918">
            Traction & Current Status
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-919">
            <MetricCard number="6" label="Months in Development" data-id="element-920" />
            <MetricCard number="1,335" label="Real Conversations Generated" data-id="element-921" />
            <MetricCard number="3x" label="Increase in Meeting Bookings" data-id="element-922" />
            <MetricCard number="20-27%" label="Reply Rate (vs 4-5% baseline)" data-id="element-923" />
          </div>
          <div className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-924">
            <h3 className="font-semibold text-gray-900 mb-3" data-id="element-925">
              Current Progress
            </h3>
            <ul className="space-y-2 text-gray-700" data-id="element-926">
              <li data-id="element-927">
                ✓ <strong data-id="element-928">Beta version live</strong> in{' '}
                <a href="https://set-sell.com" target="_blank" rel="noopener noreferrer" className="text-[#6366f1] hover:underline" data-id="element-929">
                  Set-Sell.com
                </a>{' '}
                agency operations
              </li>
              <li data-id="element-930">
                ✓{' '}
                <strong data-id="element-931">
                  17,512 invites sent, 5,173 accepted (29.5%), 1,335 responses
                  (25.8%)
                </strong>{' '}
                - proven beta results
              </li>
              <li data-id="element-932">
                ✓{' '}
                <strong data-id="element-933">
                  End-to-end automated personalized LinkedIn sequences live
                </strong>
              </li>
              <li data-id="element-934">
                ✓ <strong data-id="element-935">Proven results:</strong> 3x meeting bookings, 20-27%
                reply rates
              </li>
              <li data-id="element-936">
                ✓ <strong data-id="element-937">Team established:</strong> Venezuela dev team +
                founders (Lucian, Irina)
              </li>
            </ul>
          </div>
        </div>
      </section>
      {/* Market Landscape Section */}
      <section className="py-16 bg-white" data-id="element-938">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-939">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-940">
            Market Landscape
          </h2>
          {/* Market Overview */}
          <div className="bg-[#6366f1]/5 rounded-xl p-8 mb-8" data-id="element-941">
            <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-942">
              The Fragmented Market Reality
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-943">
              The AI sales automation space has exploded with $3.5B+ invested in
              2024, but the market remains fragmented into three disconnected
              categories:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-944">
              <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-945">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="element-946">
                  Data Enrichment
                </h4>
                <p className="text-sm text-gray-600 mb-3" data-id="element-947">
                  Clay, Apollo, LeadIQ
                </p>
                <p className="text-sm text-gray-700" data-id="element-948">
                  Great at finding prospects, but require manual export and
                  separate tools for outreach
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-949">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="element-950">
                  AI Copy Assistants
                </h4>
                <p className="text-sm text-gray-600 mb-3" data-id="element-951">
                  Lavender, Lyne, Regie
                </p>
                <p className="text-sm text-gray-700" data-id="element-952">
                  Help write better messages, but don't handle prospecting or
                  automation
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-953">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="element-954">
                  Outreach Automation
                </h4>
                <p className="text-sm text-gray-600 mb-3" data-id="element-955">
                  SmartLead, Outplay, Amplemarket
                </p>
                <p className="text-sm text-gray-700" data-id="element-956">
                  Automate sending, but use generic personalization (just
                  name/company swaps)
                </p>
              </div>
            </div>
            <div className="bg-white rounded-lg p-6 border-2 border-[#6366f1]" data-id="element-957">
              <p className="text-gray-900 font-semibold text-lg mb-2" data-id="element-958">
                The Result?
              </p>
              <p className="text-gray-700" data-id="element-959">
                Sales teams juggle 5-7 tools, spending 80% of their time on
                setup and data transfer instead of selling.{' '}
                <strong data-id="element-960">
                  UseGigi fills the missing gap between data intelligence,
                  personalization, and outreach automation—a "ChatGPT for SDRs."
                </strong>
              </p>
            </div>
          </div>
          {/* Competitive Positioning */}
          <div className="mb-8" data-id="element-961">
            <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-962">
              How UseGigi Compares
            </h3>
            <div className="space-y-4" data-id="element-963">
              <CompetitorComparison competitor="11x.ai" competitorUrl="https://11x.ai" stage="Seed" strength="Autonomous 'AI employee' model for SDR tasks" gap="No LinkedIn Sales Navigator integration or psychographic profiling. Focuses on email, not LinkedIn where B2B buyers actually engage." gigiAdvantage="Gigi combines LinkedIn automation + personality assessment + chat onboarding in one flow" data-id="element-964" />
              <CompetitorComparison competitor="Humanlinker" competitorUrl="https://humanlinker.com" stage="Seed" strength="DISC personality profiling for sales outreach" gap="Requires manual data input. No automated scraping or end-to-end sequence automation." gigiAdvantage="Gigi automatically extracts personality insights from LinkedIn and executes the entire outreach sequence" data-id="element-965" />
              <CompetitorComparison competitor="Amplemarket" competitorUrl="https://amplemarket.com" stage="Series A" strength="Full-cycle outbound with data enrichment + sequences" gap="Generic personalization (name/company variables only). No AI chat onboarding or psychographic analysis." gigiAdvantage="Gigi uses behavioral psychology to craft messages that resonate with how each prospect actually thinks and communicates" data-id="element-966" />
              <CompetitorComparison competitor="Clay + Smartlead" competitorUrl="https://clay.com" stage="Series A (combined)" strength="Best-in-class data enrichment + deliverability" gap="Requires stitching together 2-3 tools manually. No unified workflow or AI-guided setup." gigiAdvantage="Gigi handles everything from 'who should I target?' to 'meeting booked' in one conversational interface" data-id="element-967" />
            </div>
          </div>
          {/* Market Opportunity */}
          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-6" data-id="element-968">
            <h3 className="font-semibold text-gray-900 mb-4" data-id="element-969">
              The White Space Opportunity
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-970">
              <div data-id="element-971">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="element-972">
                  What Exists:
                </h4>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-973">
                  <li data-id="element-974">✓ Tools that find prospects</li>
                  <li data-id="element-975">✓ Tools that write copy</li>
                  <li data-id="element-976">✓ Tools that send messages</li>
                  <li data-id="element-977">✓ Tools that track analytics</li>
                </ul>
              </div>
              <div data-id="element-978">
                <h4 className="font-semibold text-gray-900 mb-2" data-id="element-979">
                  What's Missing:
                </h4>
                <ul className="space-y-2 text-sm text-gray-700" data-id="element-980">
                  <li data-id="element-981">
                    ✗ <strong data-id="element-982">One tool that does it all</strong>
                  </li>
                  <li data-id="element-983">
                    ✗ <strong data-id="element-984">Psychology-based personalization</strong>
                  </li>
                  <li data-id="element-985">
                    ✗ <strong data-id="element-986">Conversational AI onboarding</strong>
                  </li>
                  <li data-id="element-987">
                    ✗ <strong data-id="element-988">LinkedIn-native automation</strong>
                  </li>
                </ul>
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-989">
              <p className="text-gray-700" data-id="element-990">
                <strong data-id="element-991">Market Timing:</strong> Most competitors are Seed to
                Series A stage, validating the category but leaving room for a
                differentiated approach. UseGigi enters at pre-seed with a
                unique value proposition:{' '}
                <strong data-id="element-992">
                  the only end-to-end AI SDR that combines behavioral psychology
                  with full automation.
                </strong>
              </p>
            </div>
          </div>
          {/* Link to Full Competitive Analysis */}
          <div className="text-center" data-id="element-993">
            <a href="https://docs.google.com/spreadsheets/d/1RdU2Cag4skoqmQofMB04Hn85S45v6_viCUwT7kcrGzQ/edit?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#6366f1] hover:underline font-medium" data-id="element-994">
              View Full Competitive Landscape Analysis →
            </a>
          </div>
        </div>
      </section>
      {/* Market Financial Opportunity Section */}
      <section className="py-16 bg-gray-50" data-id="element-995">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-996">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-997">
            The Money Talk: Market Size & Validation
          </h2>
          <div className="bg-white rounded-xl p-8 border border-gray-200 mb-8" data-id="element-998">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-999">
              <div data-id="element-1000">
                <h3 className="text-2xl font-bold text-[#6366f1] mb-2" data-id="element-1001">
                  $58B → $240B
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-1002">
                  AI Sales & Marketing market growth by 2030 (33% CAGR)
                </p>
                <div className="space-y-3 text-sm text-gray-700" data-id="element-1003">
                  <div className="flex justify-between" data-id="element-1004">
                    <span data-id="element-1005">AI Sales Assistant segment:</span>
                    <span className="font-semibold" data-id="element-1006">$19.6B by 2034</span>
                  </div>
                  <div className="flex justify-between" data-id="element-1007">
                    <span data-id="element-1008">Sales Intelligence segment:</span>
                    <span className="font-semibold" data-id="element-1009">$9B+ by 2030</span>
                  </div>
                </div>
              </div>
              <div className="bg-[#6366f1]/5 rounded-lg p-6" data-id="element-1010">
                <h4 className="font-semibold text-gray-900 mb-3" data-id="element-1011">
                  Translation: This isn't a nice-to-have market. It's a gold
                  rush.
                </h4>
                <p className="text-sm text-gray-700" data-id="element-1012">
                  The category is validated, growing fast, and attracting
                  serious capital. We're not convincing people they need AI
                  sales tools—they're already buying. We're just building the
                  best one.
                </p>
              </div>
            </div>
            <div className="border-t border-gray-200 pt-8" data-id="element-1013">
              <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-1014">
                Proof the Market Pays: Current Players & Their ARR
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-1015">
                <RevenueCard company="Apollo.io" arr="$150M+" description="Market leader in data enrichment" data-id="element-1016" />
                <RevenueCard company="Clay.com" arr="~$30M" description="Data enrichment darling" data-id="element-1017" />
                <RevenueCard company="Outplay.ai" arr="~$20M" description="Multi-channel automation" data-id="element-1018" />
                <RevenueCard company="SmartLead.ai" arr="$10-14M" description="Email deliverability focus" data-id="element-1019" />
                <RevenueCard company="Regie.ai" arr="~$8M" description="AI copywriting assistant" data-id="element-1020" />
                <RevenueCard company="11x.ai" arr="$2-10M" description="Autonomous AI SDR (newer entrant)" data-id="element-1021" />
              </div>
              <div className="bg-[#d5ff00]/10 rounded-lg p-6 border border-[#d5ff00]/30" data-id="element-1022">
                <p className="text-gray-900 font-semibold mb-2" data-id="element-1023">
                  The Bottom Line:
                </p>
                <p className="text-gray-700" data-id="element-1024">
                  These numbers prove strong market demand and serious capital
                  flowing into AI-driven outbound automation. Even early-stage
                  players are hitting multi-million ARR quickly. As the market
                  consolidates,{' '}
                  <strong data-id="element-1025">
                    UseGigi's end-to-end automation model positions it to
                    compete for a significant share of this rapidly scaling,
                    multi-billion-dollar industry
                  </strong>
                  — already validated by well-funded competitors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Opportunity Section */}
      <section className="py-16 bg-gray-50" data-id="element-1026">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1027">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-1028">Why Now</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1029">
            <OpportunityCard icon={<TrendingUp data-id="element-1031" />} title="AI Evolution" description="LLMs now understand context and nuance—enabling true personalization at scale" data-id="element-1030" />
            <OpportunityCard icon={<Target data-id="element-1033" />} title="Sales Efficiency Crisis" description="Companies cutting SDR headcount but need more pipeline—AI automation is the answer" data-id="element-1032" />
            <OpportunityCard icon={<Zap data-id="element-1035" />} title="Market Timing" description="$3.5B+ invested in sales AI tools in 2024—category is validated and growing" data-id="element-1034" />
          </div>
        </div>
      </section>
      {/* Business Case Section */}
      <section className="py-16 bg-gray-50" data-id="element-1036">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1037">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-1038">
            📊 Business Case
          </h2>
          <div className="bg-white rounded-xl p-8 border border-gray-200 mb-6" data-id="element-1039">
            <p className="text-lg text-gray-700 mb-6" data-id="element-1040">
              UseGigi.ai's pay-as-you-scale model charges{' '}
              <strong data-id="element-1041">$1 per qualified prospect</strong>, with clients averaging
              1,000 prospects/month and achieving a 25% engagement rate. With
              80% gross margins and rapid early adoption, UseGigi can grow
              aggressively in the first year (30% MoM) and sustain steady
              expansion (10% MoM) in the second, reaching multi-million ARR with
              minimal capital.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" data-id="element-1042">
              <div className="bg-[#6366f1]/5 rounded-lg p-4 text-center" data-id="element-1043">
                <div className="text-2xl font-bold text-[#6366f1] mb-1" data-id="element-1044">$1</div>
                <div className="text-xs text-gray-600" data-id="element-1045">Price per prospect</div>
              </div>
              <div className="bg-[#6366f1]/5 rounded-lg p-4 text-center" data-id="element-1046">
                <div className="text-2xl font-bold text-[#6366f1] mb-1" data-id="element-1047">
                  1,000
                </div>
                <div className="text-xs text-gray-600" data-id="element-1048">
                  Avg prospects/client
                </div>
              </div>
              <div className="bg-[#6366f1]/5 rounded-lg p-4 text-center" data-id="element-1049">
                <div className="text-2xl font-bold text-[#6366f1] mb-1" data-id="element-1050">
                  25%
                </div>
                <div className="text-xs text-gray-600" data-id="element-1051">Engagement rate</div>
              </div>
              <div className="bg-[#6366f1]/5 rounded-lg p-4 text-center" data-id="element-1052">
                <div className="text-2xl font-bold text-[#6366f1] mb-1" data-id="element-1053">
                  80%
                </div>
                <div className="text-xs text-gray-600" data-id="element-1054">Gross margin</div>
              </div>
            </div>
            <button onClick={() => setIsBusinessCaseOpen(true)} className="w-full py-4 bg-[#6366f1] text-white rounded-lg hover:bg-[#5457e5] font-semibold flex items-center justify-center gap-2 transition-colors" data-id="element-1055">
              View 24-Month Financial Projections
              <ChevronRight className="w-5 h-5" data-id="element-1056" />
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1057">
            <div className="bg-white rounded-lg p-6 border border-gray-200 text-center" data-id="element-1058">
              <div className="text-3xl font-bold text-[#6366f1] mb-2" data-id="element-1059">
                $7.32M
              </div>
              <div className="text-sm text-gray-600 font-medium" data-id="element-1060">
                ARR at Month 24
              </div>
            </div>
            <div className="bg-white rounded-lg p-6 border border-gray-200 text-center" data-id="element-1061">
              <div className="text-3xl font-bold text-[#6366f1] mb-2" data-id="element-1062">
                $4.9M
              </div>
              <div className="text-sm text-gray-600 font-medium" data-id="element-1063">
                Annual Gross Profit
              </div>
            </div>
            <div className="bg-white rounded-lg p-6 border border-gray-200 text-center" data-id="element-1064">
              <div className="text-3xl font-bold text-[#6366f1] mb-2" data-id="element-1065">610</div>
              <div className="text-sm text-gray-600 font-medium" data-id="element-1066">
                Active Clients
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Business Case Modal */}
      {isBusinessCaseOpen && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 overflow-y-auto" data-id="element-1067">
          <div className="bg-white rounded-xl max-w-5xl w-full my-8 relative max-h-[90vh] overflow-y-auto" data-id="element-1068">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-6 flex justify-between items-center" data-id="element-1069">
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-1070">
                📊 Business Case (24-Month Projection)
              </h3>
              <button onClick={() => setIsBusinessCaseOpen(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1071">
                <X className="w-6 h-6" data-id="element-1072" />
              </button>
            </div>
            <div className="p-8" data-id="element-1073">
              <p className="text-lg text-gray-700 mb-8" data-id="element-1074">
                UseGigi.ai's pay-as-you-scale model charges{' '}
                <strong data-id="element-1075">$1 per qualified prospect</strong>, with clients
                averaging 1,000 prospects/month and achieving a 25% engagement
                rate. With 80% gross margins and rapid early adoption, UseGigi
                can grow aggressively in the first year (30% MoM) and sustain
                steady expansion (10% MoM) in the second, reaching multi-million
                ARR with minimal capital.
              </p>
              <div className="bg-[#6366f1]/5 rounded-xl p-6 mb-8" data-id="element-1076">
                <h4 className="font-semibold text-gray-900 mb-4" data-id="element-1077">
                  Key Assumptions
                </h4>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-1078">
                  <div className="bg-white rounded-lg p-4" data-id="element-1079">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1080">
                      Price per prospect
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1081">$1</div>
                  </div>
                  <div className="bg-white rounded-lg p-4" data-id="element-1082">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1083">
                      Avg prospects/client/month
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1084">
                      1,000
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4" data-id="element-1085">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1086">
                      Engagement rate
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1087">25%</div>
                  </div>
                  <div className="bg-white rounded-lg p-4" data-id="element-1088">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1089">
                      Gross margin
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1090">80%</div>
                  </div>
                  <div className="bg-white rounded-lg p-4" data-id="element-1091">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1092">
                      Starting clients (Month 1)
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1093">10</div>
                  </div>
                  <div className="bg-white rounded-lg p-4" data-id="element-1094">
                    <div className="text-sm text-gray-600 mb-1" data-id="element-1095">
                      Growth rate
                    </div>
                    <div className="text-xl font-bold text-[#6366f1]" data-id="element-1096">
                      30% → 10%
                    </div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-1097">
                      Yr 1 → Yr 2
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8 overflow-x-auto" data-id="element-1098">
                <table className="w-full border-collapse" data-id="element-1099">
                  <thead data-id="element-1100">
                    <tr className="bg-[#6366f1] text-white" data-id="element-1101">
                      <th className="px-4 py-3 text-left rounded-tl-lg" data-id="element-1102">
                        Month
                      </th>
                      <th className="px-4 py-3 text-right" data-id="element-1103">Active Clients</th>
                      <th className="px-4 py-3 text-right" data-id="element-1104">Monthly Revenue</th>
                      <th className="px-4 py-3 text-right" data-id="element-1105">
                        Gross Profit (80%)
                      </th>
                      <th className="px-4 py-3 text-right rounded-tr-lg" data-id="element-1106">
                        ARR
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-1107">
                    <tr className="border-b border-gray-200 hover:bg-gray-50" data-id="element-1108">
                      <td className="px-4 py-3 font-semibold" data-id="element-1109">1</td>
                      <td className="px-4 py-3 text-right" data-id="element-1110">10</td>
                      <td className="px-4 py-3 text-right" data-id="element-1111">$10K</td>
                      <td className="px-4 py-3 text-right text-[#6366f1] font-semibold" data-id="element-1112">
                        $8K
                      </td>
                      <td className="px-4 py-3 text-right font-semibold" data-id="element-1113">
                        $120K
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200 hover:bg-gray-50" data-id="element-1114">
                      <td className="px-4 py-3 font-semibold" data-id="element-1115">6</td>
                      <td className="px-4 py-3 text-right" data-id="element-1116">37</td>
                      <td className="px-4 py-3 text-right" data-id="element-1117">$37K</td>
                      <td className="px-4 py-3 text-right text-[#6366f1] font-semibold" data-id="element-1118">
                        $29.6K
                      </td>
                      <td className="px-4 py-3 text-right font-semibold" data-id="element-1119">
                        $444K
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200 hover:bg-gray-50" data-id="element-1120">
                      <td className="px-4 py-3 font-semibold" data-id="element-1121">12</td>
                      <td className="px-4 py-3 text-right" data-id="element-1122">190</td>
                      <td className="px-4 py-3 text-right" data-id="element-1123">$190K</td>
                      <td className="px-4 py-3 text-right text-[#6366f1] font-semibold" data-id="element-1124">
                        $152K
                      </td>
                      <td className="px-4 py-3 text-right font-semibold" data-id="element-1125">
                        $2.28M
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200 hover:bg-gray-50" data-id="element-1126">
                      <td className="px-4 py-3 font-semibold" data-id="element-1127">18</td>
                      <td className="px-4 py-3 text-right" data-id="element-1128">339</td>
                      <td className="px-4 py-3 text-right" data-id="element-1129">$339K</td>
                      <td className="px-4 py-3 text-right text-[#6366f1] font-semibold" data-id="element-1130">
                        $271K
                      </td>
                      <td className="px-4 py-3 text-right font-semibold" data-id="element-1131">
                        $4.06M
                      </td>
                    </tr>
                    <tr className="bg-[#6366f1]/5 hover:bg-[#6366f1]/10" data-id="element-1132">
                      <td className="px-4 py-3 font-bold" data-id="element-1133">24</td>
                      <td className="px-4 py-3 text-right font-bold" data-id="element-1134">610</td>
                      <td className="px-4 py-3 text-right font-bold" data-id="element-1135">$610K</td>
                      <td className="px-4 py-3 text-right text-[#6366f1] font-bold" data-id="element-1136">
                        $488K
                      </td>
                      <td className="px-4 py-3 text-right font-bold text-lg" data-id="element-1137">
                        $7.32M
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="bg-[#d5ff00]/10 rounded-lg p-6 border border-[#d5ff00]/30" data-id="element-1138">
                <p className="text-gray-900 font-semibold mb-2" data-id="element-1139">Summary</p>
                <p className="text-gray-700" data-id="element-1140">
                  Over 24 months, UseGigi.ai can scale from 10 to 600+ clients,
                  reaching <strong data-id="element-1141">$7.32M ARR</strong> and{' '}
                  <strong data-id="element-1142">~$4.9M annual gross profit</strong> with only $100K in
                  pre-seed capital. The combination of transparent pricing, high
                  engagement rates, and strong margins gives a clear path to
                  profitability and investor returns within two years.
                </p>
              </div>
            </div>
          </div>
        </div>}
      {/* Business Model Section */}
      <section className="py-16 bg-white" data-id="element-1143">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1144">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-1145">
            Business Model & Go-To-Market
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1146">
            <div className="bg-[#6366f1]/5 rounded-xl p-6" data-id="element-1147">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1148">
                Revenue Model
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-1149">
                <li data-id="element-1150">
                  • <strong data-id="element-1151">Freemium:</strong> 20 credits/month free (1
                  campaign)
                </li>
                <li data-id="element-1152">
                  • <strong data-id="element-1153">Pro Plan:</strong> $99/month (100 credits, unlimited
                  campaigns)
                </li>
                <li data-id="element-1154">
                  • <strong data-id="element-1155">Enterprise:</strong> Custom pricing for teams 10+
                </li>
                <li data-id="element-1156">
                  • <strong data-id="element-1157">Target:</strong> $2M+ ARR within 12 months, scaling
                  to $7M+ by month 24
                </li>
              </ul>
            </div>
            <div className="bg-[#6366f1]/5 rounded-xl p-6" data-id="element-1158">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1159">
                Go-To-Market Strategy
              </h3>
              <ul className="space-y-3 text-gray-700" data-id="element-1160">
                <li data-id="element-1161">
                  • <strong data-id="element-1162">Phase 1:</strong> Walk the talk: running gigi
                  campaigns to attract users
                </li>
                <li data-id="element-1163">
                  • <strong data-id="element-1164">Phase 2:</strong> Launch on Product Hunt and similar
                </li>
                <li data-id="element-1165">
                  • <strong data-id="element-1166">Phase 3:</strong> Direct B2B sales to SMBs and
                  startups
                </li>
                <li data-id="element-1167">
                  • <strong data-id="element-1168">Phase 4:</strong> Enterprise expansion
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Investment Opportunity Section */}
      <section className="py-16 bg-gradient-to-b from-[#6366f1] to-[#5457e5] text-white" data-id="element-1169">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1170">
          <div className="text-center mb-12" data-id="element-1171">
            <h2 className="text-4xl font-bold mb-6" data-id="element-1172">
              💰 Investment Opportunity
            </h2>
            <p className="text-xl opacity-95 max-w-3xl mx-auto leading-relaxed" data-id="element-1173">
              We are raising <strong data-id="element-1174">$100,000 pre-seed</strong> to bring
              UseGigi.ai live and accelerate go-to-market. In return, investors
              receive <strong data-id="element-1175">10% equity at a $1M post-money valuation</strong>,
              plus a performance-based option to invest an additional $100,000
              for another 10% at the same valuation after 6 months — if the
              business plan milestones are achieved.
            </p>
          </div>
          {/* Milestone Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-1176">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20" data-id="element-1177">
              <div className="flex items-start justify-between mb-4" data-id="element-1178">
                <div data-id="element-1179">
                  <div className="text-[#d5ff00] font-bold text-sm mb-2" data-id="element-1180">
                    PHASE 1: LAUNCH
                  </div>
                  <div className="text-2xl font-bold mb-1" data-id="element-1181">0–3 Months</div>
                </div>
                <div className="bg-[#d5ff00] text-gray-900 px-3 py-1 rounded-full text-sm font-bold" data-id="element-1182">
                  NOW
                </div>
              </div>
              <div className="space-y-4" data-id="element-1183">
                <div data-id="element-1184">
                  <div className="text-sm opacity-75 mb-1" data-id="element-1185">Objective</div>
                  <div className="font-semibold" data-id="element-1186">
                    Complete self-service AI SDR platform & onboard 10 clients
                  </div>
                </div>
                <div className="pt-4 border-t border-white/20" data-id="element-1187">
                  <div className="text-sm opacity-75 mb-1" data-id="element-1188">
                    Investor Opportunity
                  </div>
                  <div className="text-xl font-bold text-[#d5ff00]" data-id="element-1189">
                    $100K for 10% equity
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20" data-id="element-1190">
              <div className="flex items-start justify-between mb-4" data-id="element-1191">
                <div data-id="element-1192">
                  <div className="text-[#d5ff00] font-bold text-sm mb-2" data-id="element-1193">
                    PHASE 2: TRACTION
                  </div>
                  <div className="text-2xl font-bold mb-1" data-id="element-1194">4–6 Months</div>
                </div>
                <div className="bg-white/20 text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-1195">
                  OPTION
                </div>
              </div>
              <div className="space-y-4" data-id="element-1196">
                <div data-id="element-1197">
                  <div className="text-sm opacity-75 mb-1" data-id="element-1198">Objective</div>
                  <div className="font-semibold" data-id="element-1199">
                    Reach 37+ clients and $37K MRR
                  </div>
                </div>
                <div className="pt-4 border-t border-white/20" data-id="element-1200">
                  <div className="text-sm opacity-75 mb-1" data-id="element-1201">
                    Additional Investment Option
                  </div>
                  <div className="text-xl font-bold text-[#d5ff00]" data-id="element-1202">
                    +$100K for +10% equity at same valuation
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Use of Funds */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20" data-id="element-1203">
            <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-1204">
              Use of Funds
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1205">
              <div className="text-center" data-id="element-1206">
                <div className="w-16 h-16 bg-[#d5ff00] rounded-full flex items-center justify-center mx-auto mb-4 text-4xl" data-id="element-1207">
                  🚀
                </div>
                <div className="text-3xl font-bold mb-2" data-id="element-1208">50%</div>
                <div className="text-sm opacity-90" data-id="element-1209">Product finalization</div>
                <div className="text-xs opacity-75 mt-1" data-id="element-1210">
                  (AI automation & integrations)
                </div>
              </div>
              <div className="text-center" data-id="element-1211">
                <div className="w-16 h-16 bg-[#d5ff00] rounded-full flex items-center justify-center mx-auto mb-4 text-4xl" data-id="element-1212">
                  📈
                </div>
                <div className="text-3xl font-bold mb-2" data-id="element-1213">40%</div>
                <div className="text-sm opacity-90" data-id="element-1214">
                  Marketing & client acquisition
                </div>
                <div className="text-xs opacity-75 mt-1" data-id="element-1215">
                  (Go-to-market execution)
                </div>
              </div>
              <div className="text-center" data-id="element-1216">
                <div className="w-16 h-16 bg-[#d5ff00] rounded-full flex items-center justify-center mx-auto mb-4 text-4xl" data-id="element-1217">
                  ⚙️
                </div>
                <div className="text-3xl font-bold mb-2" data-id="element-1218">10%</div>
                <div className="text-sm opacity-90" data-id="element-1219">Infrastructure & ops</div>
                <div className="text-xs opacity-75 mt-1" data-id="element-1220">
                  (Systems & support)
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Team Section */}
      <section className="py-16 bg-white" data-id="element-1221">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1222">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-1223">
            Founding Team
          </h2>
          {/* Track Record Section */}
          <div className="bg-gradient-to-r from-[#6366f1]/5 to-[#d5ff00]/5 rounded-xl p-8 mb-12 border border-[#6366f1]/20" data-id="element-1224">
            <div className="flex items-start gap-4" data-id="element-1225">
              <div className="w-12 h-12 bg-[#6366f1] rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-1226">
                <TrendingUp className="w-6 h-6 text-white" data-id="element-1227" />
              </div>
              <div data-id="element-1228">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1229">
                  Proven Track Record: Previous Exit
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-1230">
                  The founding team has successfully built and exited a previous
                  venture, demonstrating their ability to execute, scale, and
                  deliver returns to investors. This experience informs
                  UseGigi's strategic approach and go-to-market execution.
                </p>
                <div className="inline-flex items-center gap-2 bg-white rounded-lg px-4 py-2 border border-gray-200" data-id="element-1231">
                  <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-1232"></div>
                  <span className="text-sm font-semibold text-gray-900" data-id="element-1233">
                    Successful Exit Achieved
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1234">
            <TeamMember name="Irina" role="Founder & CEO" description="17+ years in B2B sales, over 50 scaled projects. Runs Set-Sell.com agency where Gigi is battle-tested daily." image="https://uploadthingy.s3.us-west-1.amazonaws.com/uy5NWm7gwFbrAv2AbUN2KJ/irina_lam.jpg" data-id="element-1235" />
            <TeamMember name="Lucian" role="Co-Founder & COO" description="20 years in tech, sales, staffing and recruiting, startups and automation." image="https://uploadthingy.s3.us-west-1.amazonaws.com/98HoHnaDpqofrTai9w3RpF/lucian_cretu.jpg" data-id="element-1236" />
            <TeamMember name="Dev Team" role="Engineering" description="Various independent contractors with expertise in AI, automation and scalable systems." data-id="element-1237" />
          </div>
        </div>
      </section>
      {/* Footer */}
      <section className="py-12 bg-gray-900 text-white" data-id="element-1238">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1239">
          <h3 className="text-2xl font-bold mb-4" data-id="element-1240">Ready to Learn More?</h3>
          <p className="text-gray-400 mb-6" data-id="element-1241">
            Contact us to schedule a demo or discuss investment opportunities
          </p>
          <a href="mailto:usegigi@usegigi.ai" className="inline-block px-8 py-3 bg-[#d5ff00] text-gray-900 rounded-lg font-semibold hover:bg-[#c0e600] transition-colors" data-id="element-1242">
            Get in Touch
          </a>
        </div>
      </section>
    </div>;
};
const ProblemCard = ({
  title,
  description
}: {
  title: string;
  description: string;
}) => <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-1243">
    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-1244">{title}</h3>
    <p className="text-gray-600" data-id="element-1245">{description}</p>
  </div>;
const FeatureItem = ({
  title,
  description
}: {
  title: string;
  description: string;
}) => <div data-id="element-1246">
    <h4 className="font-semibold text-gray-900 mb-1" data-id="element-1247">{title}</h4>
    <p className="text-gray-600 text-sm" data-id="element-1248">{description}</p>
  </div>;
const MetricCard = ({
  number,
  label
}: {
  number: string;
  label: string;
}) => <div className="bg-white rounded-lg p-6 border border-gray-200 text-center" data-id="element-1249">
    <div className="text-3xl font-bold text-[#6366f1] mb-2" data-id="element-1250">{number}</div>
    <div className="text-sm text-gray-600" data-id="element-1251">{label}</div>
  </div>;
const CompetitorComparison = ({
  competitor,
  competitorUrl,
  stage,
  strength,
  gap,
  gigiAdvantage
}: {
  competitor: string;
  competitorUrl: string;
  stage: string;
  strength: string;
  gap: string;
  gigiAdvantage: string;
}) => <div className="bg-gray-50 rounded-lg p-6 border border-gray-200" data-id="element-1252">
    <div className="flex items-start justify-between mb-3" data-id="element-1253">
      <div data-id="element-1254">
        <a href={competitorUrl} target="_blank" rel="noopener noreferrer" className="text-lg font-semibold text-[#6366f1] hover:underline" data-id="element-1255">
          {competitor}
        </a>
        <span className="ml-3 text-sm text-gray-500" data-id="element-1256">({stage})</span>
      </div>
    </div>
    <div className="space-y-3 text-sm" data-id="element-1257">
      <div data-id="element-1258">
        <span className="font-semibold text-gray-900" data-id="element-1259">Their Strength: </span>
        <span className="text-gray-700" data-id="element-1260">{strength}</span>
      </div>
      <div data-id="element-1261">
        <span className="font-semibold text-gray-900" data-id="element-1262">The Gap: </span>
        <span className="text-gray-700" data-id="element-1263">{gap}</span>
      </div>
      <div className="pt-2 border-t border-gray-200" data-id="element-1264">
        <span className="font-semibold text-[#6366f1]" data-id="element-1265">Gigi's Advantage: </span>
        <span className="text-gray-700" data-id="element-1266">{gigiAdvantage}</span>
      </div>
    </div>
  </div>;
const CompetitorInsight = ({
  competitor,
  competitorUrl,
  gap
}: {
  competitor: string;
  competitorUrl: string;
  gap: string;
}) => <div className="bg-white rounded-lg p-4 border border-gray-200" data-id="element-1267">
    <div className="font-semibold text-gray-900 mb-1" data-id="element-1268">
      <a href={competitorUrl} target="_blank" rel="noopener noreferrer" className="text-[#6366f1] hover:underline" data-id="element-1269">
        {competitor}
      </a>
    </div>
    <div className="text-sm text-gray-600" data-id="element-1270">{gap}</div>
  </div>;
const OpportunityCard = ({
  icon,
  title,
  description
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) => <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-1271">
    <div className="w-12 h-12 bg-[#6366f1]/10 rounded-lg flex items-center justify-center mb-4 text-[#6366f1]" data-id="element-1272">
      {icon}
    </div>
    <h3 className="font-semibold text-gray-900 mb-2" data-id="element-1273">{title}</h3>
    <p className="text-gray-600 text-sm" data-id="element-1274">{description}</p>
  </div>;
const TeamMember = ({
  name,
  role,
  description,
  image
}: {
  name: string;
  role: string;
  description: string;
  image?: string;
}) => <div className="text-center" data-id="element-1275">
    {image ? <img src={image} alt={name} className="w-32 h-32 rounded-full mx-auto mb-4 object-cover" data-id="element-1276" /> : <div className="w-32 h-32 bg-[#6366f1]/10 rounded-full mx-auto mb-4 flex items-center justify-center" data-id="element-1277">
        <Users className="w-12 h-12 text-[#6366f1]" data-id="element-1278" />
      </div>}
    <h3 className="font-semibold text-gray-900 mb-1" data-id="element-1279">{name}</h3>
    <div className="text-sm text-[#6366f1] mb-2" data-id="element-1280">{role}</div>
    <p className="text-sm text-gray-600" data-id="element-1281">{description}</p>
  </div>;
const RevenueCard = ({
  company,
  arr,
  description
}: {
  company: string;
  arr: string;
  description: string;
}) => <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1282">
    <div className="flex justify-between items-start mb-2" data-id="element-1283">
      <span className="font-semibold text-gray-900" data-id="element-1284">{company}</span>
      <span className="text-[#6366f1] font-bold text-sm" data-id="element-1285">{arr}</span>
    </div>
    <p className="text-xs text-gray-600" data-id="element-1286">{description}</p>
  </div>;